import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { setCallbackLink, setUpperPopup } from "../store/reducers/general"
import { setCurrentTeam, addTeam } from "../store/reducers/user"
import { userService } from "../services/user"
import { rolesTranslations } from "../services/data"

export function Invite() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { teamId, channelName, imageId, roles, recieverId } = useParams()
    const user = useSelector(state => state.user)

    useEffect(() => {
        if (!user._id) {
            dispatch(setCallbackLink(`/invite/${teamId}/${channelName}/${imageId}/${roles}/${recieverId}`))
            navigate('/login')
        }
    }, [])

    const accept = async () => {
        try {
            const team = await userService.acceptInvite(teamId)
            dispatch(addTeam(team))
            dispatch(setCurrentTeam(team))
            navigate('/')
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const decline = async () => {
        try {
            await userService.rejectInvite(teamId)
            navigate('/')
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const formattedRoles = roles.split('-').map(role => rolesTranslations[role]).join(', ')

    if (user._id !== recieverId) return <section className="invite-page">
        <h3>אופס, נראה שהזמנה זו אינה מיועדת לך.</h3>
        <p className="clickable main7 underline" onClick={() => navigate('/')}>חזור לדף הבית</p>
    </section>

    return <section className="invite-page">
        <div className="invite-details">
            <img src={'https://res.cloudinary.com/dfmtbntrc/image/upload/' + imageId} />
            <p>{channelName} הזמין אותך להיות {formattedRoles} בערוץ שלו</p>
        </div>
        <div className='buttons-wrapper'>
            <div onClick={decline} className="lighter" >סירוב</div>
            <button onClick={accept} className="bolder" >אישור</button>
        </div>
    </section>
}

